import { Col, Form, Input, InputNumber, Radio, Row } from 'antd';
import { FormInstance } from 'antd/lib/form';
import React from 'react';

interface Props {
    form: FormInstance
    fieldId: string
    fieldName: string // label in UI
}

const WaitingTimeFilter = ({
    form,
    fieldId,
    fieldName,
}: Props) => {

    const onChange = () => {
        let min = form.getFieldValue('min') ?? 0
        let max = form.getFieldValue('max') ?? 0
        let unit = form.getFieldValue('unit')
        form.setFieldValue(fieldId, `${min},${max},${unit}`)
        form.setFieldValue(`${fieldId}_labels`, [`${min} to ${max} ${unit}`])
    }

    const value = form.getFieldValue(fieldId)

    let initMin = ''
    let initMax = ''
    let initUnit = 'days'
    if (value) {
        initMin = value[0]
        initMax = value[1]
        initUnit = value[2]
    }

    return <>
        <Row>
            <Col span={24}>
                Enter a minimum AND/OR maximum 'Waiting time' below, in days OR weeks.
                Only admissions with these waiting times will be included in the results.
            </Col>
        </Row>
        <Row>
            <Form.Item name={fieldId} hidden={true}>
                <Input />
            </Form.Item>
            <Form.Item name={`${fieldId}_labels`} hidden={true}>
                <Input />
            </Form.Item>
            <Col span={12} style={{ padding: "5px" }}>
                <Form.Item name={'min'} label={'Minimum'} initialValue={initMin}>
                    <InputNumber onChange={onChange} />
                </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "5px" }}>
                <Form.Item name={'max'} label={'Maximum'} initialValue={initMax}>
                    <InputNumber onChange={onChange} />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item name={'unit'} label={'Maximum'} initialValue={initUnit}>
                    <Radio.Group onChange={onChange}>
                        <Radio value={'days'}>Days</Radio>
                        <Radio value={'weeks'}>Weeks</Radio>
                    </Radio.Group>
                </Form.Item>
            </Col>
        </Row>
    </>

}

export default WaitingTimeFilter